export default __webpack_public_path__ + "media/images/info-51b38a9bc27192575a94df21cbbcf73c.png";